import { baseApi } from "../baseApi";
import { buildQueryParams } from "../queryUtils";

export const claimsApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [
      "ClaimsAudit",
      "ClaimsPayer",
      "ClaimsGeneration",
      "ClaimProcessing",
      "BulkProcessings",
      "BulkJobFailures",
      "ApprovalManagement",
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getInsuranceVisitsWithoutSlots: builder.query({
        query: (payload) => ({
          url: "/v3/visit/getInsuranceVisitsWithoutSlots",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ApprovalManagement"],
        keepUnusedDataFor: 300,
      }),

      getAuditResults: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/audit-results/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ClaimsAudit"],
      }),

      getAuditResultsByIssue: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/audit-results/list-by-issue",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ClaimsAudit"],
      }),

      getPayers: builder.query({
        query: (payload = {}) => ({
          url: "/v3/payer/get",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ClaimsPayer"],
      }),

      getClaimGenerationVisits: builder.query({
        query: (payload) => ({
          url: "/v3/visit/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ClaimsGeneration"],
      }),

      getClaimProcessingList: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listClaims",
          method: "POST",
          body: payload,
        }),
        providesTags: ["ClaimProcessing"],
      }),

      getClaimsByPayerMonth: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/claimsByPayerMonth",
          method: "POST",
          body: payload,
        }),
        providesTags: ["BulkProcessings"],
      }),

      getBulkJobFailures: builder.query({
        query: (params) => ({
          url: "/v3/invoices/bulkJobFailures",
          method: "GET",
          params: buildQueryParams(params),
        }),
        providesTags: ["BulkJobFailures"],
      }),
    }),
  });

export const {
  useGetInsuranceVisitsWithoutSlotsQuery,
  useLazyGetInsuranceVisitsWithoutSlotsQuery,
  useGetAuditResultsQuery,
  useLazyGetAuditResultsQuery,
  useGetAuditResultsByIssueQuery,
  useLazyGetAuditResultsByIssueQuery,
  useGetPayersQuery,
  useLazyGetPayersQuery,
  useGetClaimGenerationVisitsQuery,
  useLazyGetClaimGenerationVisitsQuery,
  useGetClaimProcessingListQuery,
  useLazyGetClaimProcessingListQuery,
  useGetClaimsByPayerMonthQuery,
  useLazyGetClaimsByPayerMonthQuery,
  useGetBulkJobFailuresQuery,
  useLazyGetBulkJobFailuresQuery,
} = claimsApi;
